export enum ActiveLocationColumnKeys {
  INTERNAL_NUMBER = 'internalNumber',
  NAME = 'name',
  LOCATION_TYPE = 'type',
  LOCATION_CATEGORY = 'category',
  COST_CENTER = 'costCenter',
  ADDRESS = 'address',
  ORGANISATION = 'organisationName',
  SCAN_CODE = 'scanCode',
  START_DATE = 'start',
  END_DATE = 'end',
  DESCRIPTION = 'description',
  POSITION = 'position',
  LABELS = 'labels',
}
